import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getExhibitorById } from "api/exhibitor.api";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";


export default function ViewExhibitor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewerOpen, setViewerOpen] = useState(false);


  useEffect(() => {
    fetchExhibitor();
  }, []);

  const fetchExhibitor = async () => {
    try {
      const res = await getExhibitorById(id);
      setData(res.data.data);
    } catch (error) {
      console.error("Failed to load company", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p className="p-6">Loading...</p>;
  }

  if (!data) return null;

  return (
    <div className="p-6">
      <h2 className="mb-4 text-xl font-bold">View Exhibitor</h2>

      <Card title="Organizer Information">
              <Info label="Name" value={data.title} />
              <Info label="Email" value={data.email} />
              <Info label="Password" value={data.password} />
              <Info
                label="Mobile"
                value={`${data.country_code} ${data.phone_number}`}
              />
              <Info label="Website" value={data.website} />
              <Info label="Manager Name" value={data.manager_name} />
              <Info label="Manager Email" value={data.manager_email} /> 
              <Info label="Status" value={data.status} />
              <Info
                label="Eco Friendly"
                value={data.eco_friendly ? "Yes" : "No"}
              />


              {data.logo_image && (
                <div className="col-span-2">
                  <p className="text-sm text-gray-500 mb-1">Logo</p>
                  <>
                  <img
                    src={getImageUrl(data.logo_image)}
                    alt="Banner Logo"
                    className="h-24 rounded-xl border"
                     onClick={() => setViewerOpen(true)} 
                  />
                  <ImageViewer
                                open={viewerOpen}
                                onClose={() => setViewerOpen(false)}
                                src={getImageUrl(data.logo_image)}
                              />
                              </>
                </div>
              )}
            </Card>

      <button
        onClick={() => navigate(-1)}
        className="mt-6 rounded bg-gray-300 px-6 py-2"
      >
        Back
      </button>
    </div>
  );
}

function Card({ title, children }) {  
  return (
    <div className="rounded-[20px] bg-white p-6 shadow-3xl">
      <h3 className="mb-4 text-lg font-semibold">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className="font-medium">{value || "-"}</p>
    </div>
  );
}
